import React from "react";

export interface IToggleSwitch {
  id: string;
  name: string;
  checked: boolean;
  onChange: Function;
  small?: boolean;
  ToggleInnerDataYes?: string;
  ToggleInnerDataNo?: string;
  disabled?: boolean;
  switchcolorClass?: string;
  parentClassName?: string;
}

const ToggleSwitch = (props: IToggleSwitch) => {
  function handleKeyPress(e: any) {
    if (e.keyCode !== 32) return;
    e.preventDefault();
    props.onChange(!props.checked);
  }

  return (
    <>
      <div
        className={
          `toggle-switch  ${props.parentClassName}` +
          (props.small == true ? " big-switch" : "")
        }
      >
        <input
          type="checkbox"
          name={props.name}
          className="toggle-switch-checkbox"
          id={props.id}
          checked={props.checked}
          onChange={(e) => props.onChange(e.target.checked)}
          disabled={props.disabled}
        />
        {props.id ? (
          <label
            className={`${props.switchcolorClass} ${
              props.checked
                ? "toggle-switch-label e-switch-active"
                : "toggle-switch-label"
            } ${props.disabled ? "cursor-not-allowed" : ""}`}
            tabIndex={props.disabled ? -1 : 1}
            onKeyDown={(e) => handleKeyPress(e)}
            htmlFor={props.id}
          >
            <span
              className="toggle-switch-inner"
              data-yes={props.ToggleInnerDataYes ?? " "}
              data-no={props.ToggleInnerDataNo ?? " "}
            />
            <span
              className={`${props.switchcolorClass} ${props.disabled ? "cursor-not-allowed" : ""} ${
                (props.checked
                  ? "toggle-switch-switch e-switch-active"
                  : "toggle-switch-switch") +
                (props.small == true ? " big-switch" : "")
              }`}
            />
          </label>
        ) : null}
      </div>
    </>
  );
};

export default ToggleSwitch;
